export default {
    set: (data, key, item) => {
        if (Array.isArray(data)) {
            data = data.map((t, i) => {
                if (i === key) return item;

                return t;
            });
        } else {
            data[key] = item;
        }

        return data;
    },

    delete: (data, key) => {
        if (Array.isArray(data)) {
            data = data.filter((t, i) => i !== key);
        } else {
            delete data[key];
        }

        return data;
    },
};
